import unveil from 'ui/lazy-load/unveil';

import initializeWishListView from './initializeWishListView';

function loadWishListItems (viewType, callback) {

	window.lp.utils.showStatusIndicator();

	// render the view
	$('#wishlistBody').load('/wish-list/WishListView/', () => {

		initializeWishListView(false, viewType);
		$(lp).trigger('rebindUIElements');

		if (typeof callback === 'function') {

			callback();

		}

		if ($('.btnQuickEstimate').hasClass('disabled')) {

			$('.wishlistItemPrice').show();

		}
		window.lp.utils.hideStatusIndicator();
		// init unveil lazy loading
		unveil('img.unveil[data-src]');

	});

}

export default loadWishListItems;
